import React, { useImperativeHandle, useState } from 'react';
import classes from './WordBank.module.scss';
import clsx from 'clsx';
import { useAnimate, motion, stagger } from 'framer-motion';

export const WordBank = (props) => {
    const { isBottomBank, children, animated, ref } = props;

    const [containerRef, animateContainer] = useAnimate();
    const [hasAnimated, setHasAnimated] = useState(false);

    useImperativeHandle(ref, () => ({
        entryAnimation: async (options) => {
            await animateContainer(containerRef.current, { scale: 1 }, {
                type: "tween",
                duration: 0.5,
                ease: [0.25, 1, 0.5, 1],
                ...options
            });

            await animateContainer("[data-word]", { opacity: 1 }, { 
                    delay: stagger(0.05),
                    type: "tween",
                    duration: 0.3,
                }
            )

            setHasAnimated(true);
        }
    }));

    const showAnimated = animated && !hasAnimated;

    return (
        <div className={clsx(classes.layout, isBottomBank && classes.bottomBank)}>
            <motion.div ref={containerRef} initial={{ scale: animated ? 0 : 1 }} className={clsx(classes.wordContainer, classes.scrollbar, showAnimated && classes.animated)}>
                <div className={classes.wordContainerWrapper}>
                    {children}
                </div>
            </motion.div>
        </div>
    )
}